// extracted by mini-css-extract-plugin
module.exports = {"anchor":"style_anchor__rGrrI","proxy":"style_proxy__qMu1l","proxyTo":"style_proxyTo__Pbq0b"};